import { getMediaServiceUrl } from "@campgladiator/cg-common.config.config";
import { Request } from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";

export type UploadMediaArgs = {
  image: File;
  fileName: string;
  bucketName: string;
};

export type UploadMediaResponse = {
  url: string;
};

const unknownErrorMessage = "An unknown error occurred";

/**
 * Uploads media to the specified bucket.
 * @param bucketName - The name of the bucket where the media will be uploaded.
 * @param fileName - The name of the image
 * @param image - The image image to be uploaded.
 * @returns The url of the uploaded media.
 * @throws If an error occurs during the upload process.
 */
export const uploadMedia = async ({
  bucketName,
  fileName,
  image,
}: UploadMediaArgs): Promise<UploadMediaResponse> => {
  const method = "POST";
  const formData = new FormData();
  formData.append("image", image);
  formData.append("fileName", fileName);
  formData.append("bucketName", bucketName);

  try {
    const request: Request = {
      requestConfig: {
        method,
        url: { baseUrl: getMediaServiceUrl(), endpoint: "/v1/media/images" },
      },
      body: formData,
    };
    const response = await fetchRequest({
      request,
      type: "form",
    });
    const url = await response.text();

    const result: UploadMediaResponse = { url };

    return Promise.resolve(result);
  } catch (error: any) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || unknownErrorMessage;
    return Promise.reject(new Error(errorMessage));
  }
};
